import { UtpCardModal, UtpCardStructure } from 'common/components';
import { METAL_ROOF_CDN_PATH } from '../../metal-roof-constants';
import { Benefits, MaterialCalculation, QualityAssurance, Services } from './components';

const MATERIAL_CALCULATION = {
  elementName: 'Расчёт материалов',
  header: {
    title: 'Рассчитаем материалы',
  },
  description: {
    text: 'Учтём размеры и\u00A0пожелания',
  },
  image: {
    alt: 'Рассчитаем материалы',
    src: `${METAL_ROOF_CDN_PATH}/utp/material-calculation-1.png/material-calculation-1.png`,
  },
  modal: { content: MaterialCalculation },
};

const BENEFITS = {
  elementName: 'От заказа до получения - 10 дней',
  header: {
    title: 'Изготовим и\u00A0доставим за\u00A010\u00A0дней',
  },
  description: {
    text: 'сразу после заказа',
  },
  image: {
    alt: 'Быстрое производство и доставка',
    src: `${METAL_ROOF_CDN_PATH}/utp/benefits-1.png/benefits-1.png`,
  },
  modal: { content: Benefits },
};

const QUALITY_ASSURANCE = {
  elementName: 'Гарантия качества',
  header: {
    title: 'Предоставим гарантию',
  },
  description: {
    text: 'до 50 лет на\u00A0материалы',
  },
  image: {
    alt: 'Гарантия качества',
    src: `${METAL_ROOF_CDN_PATH}/utp/quality-assurance-1.png/quality-assurance-1.png`,
  },
  modal: { content: QualityAssurance },
};

const SERVICES = {
  elementName: 'Услуги Лемана ПРО',
  header: {
    title: 'Сделаем всё под ключ',
  },
  description: {
    text: 'от замера до\u00A0монтажа',
  },
  image: {
    alt: 'Услуги Лемана ПРО',
    src: `${METAL_ROOF_CDN_PATH}/utp/services-1.png/services-1.png`,
  },
  modal: { content: Services },
  type: 'service-light',
};

export const METAL_ROOF_UTP_CARD_LIST_WITH_MOUNTING: UtpCardStructure<UtpCardModal>[] = [
  MATERIAL_CALCULATION,
  BENEFITS,
  SERVICES,
  QUALITY_ASSURANCE,
];
